import { createRouter, createWebHistory } from 'vue-router'
import BlankLayoutRoutes from './BlankLayoutRoutes'
import AuthRoutes from './AuthRoutes'
import MainRoutes from './MainRoutes'
import UserRoutes from './UserRoutes'
import FormRoutes from './FormRoutes'
import FrameRoutes from './FrameRoutes'
import { useAuthStore } from '@/stores/auth'
import { useCompanyStore } from '@/stores/companyStore'
import { ElNotification } from 'element-plus'

const routes = [
    { path: '/' }, // only default, will be handled in guard
    MainRoutes,

    AuthRoutes,
    BlankLayoutRoutes,
    UserRoutes,
    FormRoutes,
    ...FrameRoutes,
    { path: '/:pathMatch(.*)*', component: () => import('@/views/authentication/Error.vue') },
]

// Determine base path dynamically
const basePath = window.location.pathname.startsWith('/hr') ? '/hr/' : ''

export const router = createRouter({
    history: createWebHistory(basePath),
    routes,
})

router.beforeEach(async (to, from, next) => {
    const auth = useAuthStore()
    const companyStore = useCompanyStore()
    const publicPages = ['/auth/login', '/auth/change-password']

    // Check if the route is under BlankLayout (no auth required)
    // We check the meta.requiresAuth on the parent route or route itself
    const isBlankLayoutRoute = to.matched.some(record => record.meta.requiresAuth === false)

    const authRequired = !publicPages.includes(to.path) && !isBlankLayoutRoute

    // Restore session if missing
    if (!auth.user) {
        const stored = localStorage.getItem('user')
        if (stored) {
            try {
                const parsed = JSON.parse(stored)
                auth.user = parsed
                // Set axios token
                // @ts-ignore
                import('@/utils/apiClient').then(({ default: axios }) => {
                    axios.defaults.headers.common['Authorization'] = `Bearer ${parsed.token}`
                })
                // Restore company
                if (auth.user.company) {
                    companyStore.company = auth.user.company
                    companyStore.companyID = auth.user.company.id
                } else if (companyStore.companies.length > 0) {
                    companyStore.company = companyStore.companies[0]
                    companyStore.companyID = companyStore.companies[0].id
                }
                // Redirect logged-in user from login page
                if (to.path === '/auth/login') {
                    return next(auth.user.homePage || '/')
                }
            } catch (err) {
                console.error('Failed to restore session:', err)
                auth.clearSession()
                return next('/auth/login')
            }
        }
    }

    // Require auth
    if (authRequired && !auth.user) {
        auth.returnUrl = to.fullPath
        return next('/auth/login')
    }

    // Redirect `/` to user homePage
    if (to.path === '/' && auth.user?.homePage) {
        return next(auth.user.homePage)
    }

    next()
})
